import type React from 'react';

import { SliderAmountSelector } from './components/SliderAmountSelector';
import { useAmountSelector } from './hooks/useAmountSelector';

export const AmountSelector: React.FC = () => {
	const {
		data: { sliderLayout },
	} = useAmountSelector();

	return (
		<div>
			<SliderAmountSelector layout={sliderLayout} />
		</div>
	);
};
